import { render } from "./faq.vue?vue&type=template&id=6e607ce2"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__